import React, { useState, useEffect } from 'react';
import { AZUL, LARANJA, VERDE, CINZA, ROXO } from '../styles/colors';
import { db, cadastrarVendedor, atualizarVendedor, cadastrarCliente, logoutUsuario, atualizarStatusPedido, listarTodosPedidos, listarProdutos, salvarProduto, atualizarProduto, deletarProduto } from '../firebase';
import { collection, getDocs, deleteDoc, doc, query, where, updateDoc } from 'firebase/firestore';

const STATUS = {
  pendente:   { label: 'Aguardando', cor: '#f59e0b', bg: '#fffbeb' },
  confirmado: { label: 'Confirmado', cor: '#3b82f6', bg: '#eff6ff' },
  em_entrega: { label: 'Em entrega', cor: '#8b5cf6', bg: '#f5f3ff' },
  entregue:   { label: 'Entregue',   cor: '#16a34a', bg: '#f0fdf4' },
};

const PROXIMOS_STATUS = {
  pendente:   'confirmado',
  confirmado: 'em_entrega',
  em_entrega: 'entregue',
  entregue:   null,
};

const LABEL_BOTAO = {
  pendente:   'Confirmar Pedido',
  confirmado: 'Em Entrega',
  em_entrega: 'Marcar Entregue',
  entregue:   null,
};

const CLOUDINARY_CLOUD  = 'dlfp8lspj';
const CLOUDINARY_PRESET = 'inove_produtos';

const DESCONTOS = [
  { id: 'd24', label: '24%', valor: 24 },
  { id: 'd16', label: '16%', valor: 16 },
  { id: 'd10', label: '10%', valor: 10 },
  { id: 'd20', label: '20%', valor: 20 },
];

const NOMES_LINHAS = {
  'L':    'Lisse',
  'LP':   'Lisse Pass',
  'MA':   'Moduluz',
  'V':    'Volutta',
  'ILB':  'Ilia',
  'B':    'Basic',
  'BE':   'Basic',
  'BC':   'Basic Condulete',
  'XBC':  'Xburg',
  'XB':   'Xburg',
  'EX':   'Extra',
  'ILV':  'Ilia',
  'VV':   'Volutta',
  'TMB':  'Tubline',
  'PL':   'Pial',
  'AD':   'AD5000',
};

function getImgUrl(img) {
  if (!img) return null;
  if (img.startsWith('http')) return img;
  return 'https://www.apoio.ind.br/media/img/produtos/' + img + '.jpg';
}

function PainelAdmin({ onNavegar, onLogout }) {
  const [abaAtiva,            setAbaAtiva]            = useState('resumo');
  const [totalPedidos,        setTotalPedidos]        = useState(0);
  const [totalPendentes,      setTotalPendentes]      = useState(0);
  const [totalFaturamento,    setTotalFaturamento]    = useState(0);
  const [pedidos,             setPedidos]             = useState([]);
  const [loadingPedidos,      setLoadingPedidos]      = useState(false);
  const [atualizando,         setAtualizando]         = useState(null);
  const [filtroStatus,        setFiltroStatus]        = useState('todos');
  const [vendedores,          setVendedores]          = useState([]);
  const [loadingVend,         setLoadingVend]         = useState(false);
  const [modalVendedor,       setModalVendedor]       = useState(false);
  const [salvandoVend,        setSalvandoVend]        = useState(false);
  const [formVend,            setFormVend]            = useState({ nome: '', email: '', telefone: '', whatsapp: '', comissao: '' });
  const [errosVend,           setErrosVend]           = useState({});
  const [clientes,            setClientes]            = useState([]);
  const [loadingClientes,     setLoadingClientes]     = useState(false);
  const [modalVincular,       setModalVincular]       = useState(null);
  const [vendedorSelecionado, setVendedorSelecionado] = useState('');
  const [vinculando,          setVinculando]          = useState(false);
  const [excluindo,           setExcluindo]           = useState(null);
  const [modalExcluido,       setModalExcluido]       = useState(null);
  const [fotoZoom,            setFotoZoom]            = useState(null);

  // ── Edicao de vendedor ──
  const [modalEditarVend,     setModalEditarVend]     = useState(null);
  const [formEditarVend,      setFormEditarVend]      = useState({ telefone: '', whatsapp: '', comissao: '' });
  const [salvandoEditarVend,  setSalvandoEditarVend]  = useState(false);

  const [modalEditarCliente,  setModalEditarCliente]  = useState(null);
  const [formCliente,         setFormCliente]         = useState({});
  const [salvandoCliente,     setSalvandoCliente]     = useState(false);
  const [excluindoCliente,    setExcluindoCliente]    = useState(null);

  const [modalNovoCliente,    setModalNovoCliente]    = useState(false);
  const [formNovoCliente,     setFormNovoCliente]     = useState({ nome: '', email: '', telefone: '', cnpj: '', razaoSocial: '', rua: '', numero: '', cidade: '', estado: '', cep: '', vendedorId: '' });
  const [errosNovoCliente,    setErrosNovoCliente]    = useState({});
  const [salvandoNovoCliente, setSalvandoNovoCliente] = useState(false);

  useEffect(() => {
    carregarVendedores();
    carregarPedidos();
    carregarClientes();
  }, []);

  async function carregarPedidos() {
    setLoadingPedidos(true);
    try {
      const lista = await listarTodosPedidos();
      lista.sort((a, b) => (b.criadoEm?.seconds || 0) - (a.criadoEm?.seconds || 0));
      setPedidos(lista);
      setTotalPedidos(lista.length);
      setTotalPendentes(lista.filter(p => p.status === 'pendente').length);
      setTotalFaturamento(lista.reduce((acc, p) => acc + (Number(p.total) || 0), 0));
    } catch (e) { console.error(e); }
    setLoadingPedidos(false);
  }

  async function carregarVendedores() {
    setLoadingVend(true);
    try {
      const q = query(collection(db, 'usuarios'), where('perfil', '==', 'vendedor'));
      const snap = await getDocs(q);
      setVendedores(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error(e); }
    setLoadingVend(false);
  }

  async function carregarClientes() {
    setLoadingClientes(true);
    try {
      const q = query(collection(db, 'usuarios'), where('perfil', '==', 'cliente'));
      const snap = await getDocs(q);
      setClientes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error(e); }
    setLoadingClientes(false);
  }

  async function handleVincularVendedor() {
    if (!modalVincular) return;
    setVinculando(true);
    try {
      await updateDoc(doc(db, 'usuarios', modalVincular.id), { vendedorId: vendedorSelecionado || null });
      await carregarClientes();
      setModalVincular(null);
      setVendedorSelecionado('');
      alert('Cliente vinculado com sucesso!');
    } catch (e) { alert('Erro ao vincular.'); }
    setVinculando(false);
  }

  async function handleAtualizarStatus(pedido) {
    const novoStatus = PROXIMOS_STATUS[pedido.status];
    if (!novoStatus) return;
    setAtualizando(pedido.id);
    try {
      await atualizarStatusPedido(pedido.id, novoStatus);
      await carregarPedidos();
    } catch (e) { alert('Erro ao atualizar status.'); }
    setAtualizando(null);
  }

  async function handleLogout() {
    try {
      await logoutUsuario();
      localStorage.removeItem('perfil');
      onLogout();
    } catch (e) { console.error(e); }
  }

  async function handleCadastrarNovoCliente() {
    const erros = {};
    if (!formNovoCliente.nome.trim())  erros.nome  = 'Nome obrigatorio';
    if (!formNovoCliente.email.trim()) erros.email = 'E-mail obrigatorio';
    setErrosNovoCliente(erros);
    if (Object.keys(erros).length > 0) return;

    setSalvandoNovoCliente(true);
    try {
      const senha = 'apoio@' + formNovoCliente.nome.toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '').substring(0, 6);

      await cadastrarCliente({
        nome:        formNovoCliente.nome,
        razaoSocial: formNovoCliente.razaoSocial,
        email:       formNovoCliente.email,
        senha,
        telefone:    formNovoCliente.telefone,
        cnpj:        formNovoCliente.cnpj,
        endereco: {
          rua:    formNovoCliente.rua,
          numero: formNovoCliente.numero,
          cidade: formNovoCliente.cidade,
          estado: formNovoCliente.estado,
          cep:    formNovoCliente.cep,
        },
        vendedorId: formNovoCliente.vendedorId || null,
      });

      alert('Cliente cadastrado!\n\nE-mail: ' + formNovoCliente.email + '\nSenha: ' + senha);
      setModalNovoCliente(false);
      setFormNovoCliente({ nome: '', email: '', telefone: '', cnpj: '', razaoSocial: '', rua: '', numero: '', cidade: '', estado: '', cep: '', vendedorId: '' });
      setErrosNovoCliente({});
      await carregarClientes();
    } catch (e) {
      const msgs = {
        'auth/email-already-in-use': 'E-mail ja cadastrado.',
        'auth/invalid-email':        'E-mail invalido.',
      };
      alert('Erro: ' + (msgs[e.code] || e.message));
    }
    setSalvandoNovoCliente(false);
  }

  function abrirEditarCliente(c) {
    setFormCliente({
      nome:        c.nome        || '',
      razaoSocial: c.razaoSocial || '',
      telefone:    c.telefone    || '',
      cnpj:        c.cnpj        || '',
      rua:         c.endereco?.rua    || '',
      numero:      c.endereco?.numero || '',
      cidade:      c.endereco?.cidade || '',
      estado:      c.endereco?.estado || '',
      cep:         c.endereco?.cep    || '',
    });
    setModalEditarCliente(c);
  }

  async function handleSalvarCliente() {
    if (!modalEditarCliente) return;
    setSalvandoCliente(true);
    try {
      await updateDoc(doc(db, 'usuarios', modalEditarCliente.id), {
        nome:        formCliente.nome,
        razaoSocial: formCliente.razaoSocial,
        telefone:    formCliente.telefone,
        cnpj:        formCliente.cnpj,
        endereco: {
          rua:    formCliente.rua,
          numero: formCliente.numero,
          cidade: formCliente.cidade,
          estado: formCliente.estado,
          cep:    formCliente.cep,
        },
      });
      await carregarClientes();
      setModalEditarCliente(null);
    } catch (e) {
      alert('Erro ao salvar cliente.');
    }
    setSalvandoCliente(false);
  }

  async function handleExcluirCliente(c) {
    if (!window.confirm('Excluir o cliente "' + c.nome + '"? Esta acao nao pode ser desfeita.')) return;
    setExcluindoCliente(c.id);
    try {
      await deleteDoc(doc(db, 'usuarios', c.id));
      await carregarClientes();
    } catch (e) {
      alert('Erro ao excluir cliente: ' + e.message);
    }
    setExcluindoCliente(null);
  }

  function mensagemConvite(c) {
    const nomeVend = nomeVendedor(c.vendedorId);
    const primeiroNome = c.nome?.split(' ')[0] || c.nome;
    return (
      'Ola ' + primeiroNome + '!\n\n' +
      'A Apoio Materiais Eletricos selecionou voce para ter acesso exclusivo ao nosso novo sistema de pedidos online - o App Apoio!\n\n' +
      'Pelo app voce pode:\n' +
      '- Ver o catalogo completo de produtos\n' +
      '- Fazer pedidos a qualquer hora\n' +
      '- Acompanhar o status da entrega em tempo real\n\n' +
      'Acesse agora:\n' +
      'https://inove-app-53fa7.web.app\n\n' +
      (c.vendedorId ? 'Seu representante: ' + nomeVend + '\n\n' : '') +
      'Qualquer duvida estamos a disposicao!\n\nEquipe Apoio Materiais Eletricos'
    );
  }

  function handleConvidarWhatsApp(c) {
    const tel = (c.telefone || '').replace(/\D/g, '');
    if (!tel) { alert('Este cliente nao tem telefone cadastrado.'); return; }
    window.open('https://wa.me/55' + tel + '?text=' + encodeURIComponent(mensagemConvite(c)), '_blank');
  }

  function handleConvidarEmail(c) {
    if (!c.email) { alert('Este cliente nao tem e-mail cadastrado.'); return; }
    const assunto = 'Voce foi selecionado para o App Apoio - Apoio Materiais Eletricos';
    window.open('mailto:' + c.email + '?subject=' + encodeURIComponent(assunto) + '&body=' + encodeURIComponent(mensagemConvite(c)), '_blank');
  }

  function validarVendedor() {
    const erros = {};
    if (!formVend.nome.trim())     erros.nome     = 'Nome obrigatorio';
    if (!formVend.email.trim())    erros.email    = 'E-mail obrigatorio';
    if (!formVend.telefone.trim()) erros.telefone = 'Telefone obrigatorio';
    if (!formVend.whatsapp.trim()) erros.whatsapp = 'WhatsApp obrigatorio';
    if (!formVend.comissao.trim()) erros.comissao = 'Comissao obrigatoria';
    setErrosVend(erros);
    return Object.keys(erros).length === 0;
  }

  async function handleSalvarVendedor() {
    if (!validarVendedor()) return;
    setSalvandoVend(true);
    try {
      const senha = "apoio@" + formVend.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '').substring(0, 6);
      await cadastrarVendedor({ nome: formVend.nome, email: formVend.email, senha, telefone: formVend.telefone, whatsapp: formVend.whatsapp, comissao: formVend.comissao });
      alert('Vendedor cadastrado!\n\nE-mail: ' + formVend.email + '\nSenha: ' + senha);
      setModalVendedor(false);
      setFormVend({ nome: '', email: '', telefone: '', whatsapp: '', comissao: '' });
      setErrosVend({});
      await carregarVendedores();
    } catch (e) {
      const msgs = { 'auth/email-already-in-use': 'E-mail ja cadastrado.', 'auth/invalid-email': 'E-mail invalido.' };
      alert('Erro: ' + (msgs[e.code] || e.message));
    }
    setSalvandoVend(false);
  }

  function abrirEditarVendedor(v) {
    setFormEditarVend({
      telefone: v.telefone || '',
      whatsapp: v.whatsapp || '',
      comissao: v.comissao !== undefined ? String(v.comissao) : '',
    });
    setModalEditarVend(v);
  }

  async function handleSalvarEditarVendedor() {
    if (!modalEditarVend) return;
    setSalvandoEditarVend(true);
    try {
      await atualizarVendedor(modalEditarVend.id, {
        telefone: formEditarVend.telefone,
        whatsapp: formEditarVend.whatsapp,
        comissao: formEditarVend.comissao,
      });
      await carregarVendedores();
      setModalEditarVend(null);
    } catch (e) {
      alert('Erro ao salvar vendedor: ' + e.message);
    }
    setSalvandoEditarVend(false);
  }

  async function handleExcluirVendedor(id) {
    if (!window.confirm('Excluir este vendedor?')) return;
    setExcluindo(id);
    try {
      const vendedor = vendedores.find(v => v.id === id);
      await deleteDoc(doc(db, 'usuarios', id));
      await carregarVendedores();
      setModalExcluido({ nome: vendedor?.nome || '', email: vendedor?.email || '' });
    } catch (e) {
      console.error(e);
      alert('Erro ao excluir vendedor: ' + e.message);
    }
    setExcluindo(null);
  }

  function handleWhatsAppVendedor(v) {
    const msg = 'Ola ' + v.nome + '! Voce foi cadastrado como vendedor no App Apoio.\n\nLink: https://inove-app-53fa7.web.app?ref=' + v.linkPersonalizado + '\nE-mail: ' + v.email;
    window.open('https://wa.me/55' + v.whatsapp.replace(/\D/g, '') + '?text=' + encodeURIComponent(msg), '_blank');
  }

  function nomeVendedor(vendedorId) {
    if (!vendedorId) return 'Sem vendedor';
    const v = vendedores.find(v => v.id === vendedorId || v.uid === vendedorId);
    return v ? v.nome : 'Vendedor';
  }

  function formatarData(ts) {
    if (!ts?.seconds) return '-';
    return new Date(ts.seconds * 1000).toLocaleDateString('pt-BR');
  }

  function formatarTotal(total) {
    return Number(total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  const inputStyle = (campo) => ({
    width: '100%', background: errosVend[campo] ? '#fff5f5' : '#f8f8f7',
    border: '1px solid ' + (errosVend[campo] ? '#fca5a5' : '#e0e0dd'),
    borderRadius: 8, padding: '9px 12px', fontSize: 13,
    outline: 'none', boxSizing: 'border-box', color: '#1a1a1a', fontFamily: 'inherit',
  });

  const inputS = {
    width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd',
    borderRadius: 8, padding: '9px 12px', fontSize: 13,
    outline: 'none', boxSizing: 'border-box', color: '#1a1a1a', fontFamily: 'inherit',
  };

  const labelS = { fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 };

  const faturamentoFormatado = totalFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const pedidosFiltrados = filtroStatus === 'todos' ? pedidos : pedidos.filter(p => p.status === filtroStatus);

  function AbaProdutos() {
    const [produtos,        setProdutos]        = useState([]);
    const [loading,         setLoading]         = useState(true);
    const [filtroLinha,     setFiltroLinha]     = useState('');
    const [modalProd,       setModalProd]       = useState(false);
    const [editando,        setEditando]        = useState(null);
    const [salvando,        setSalvando]        = useState(false);
    const [uploadando,      setUploadando]      = useState(false);
    const [descontosSel,    setDescontosSel]    = useState([]);
    const [precoCheio,      setPrecoCheio]      = useState('');
    const [ipi,             setIpi]             = useState('');
    const [form, setForm] = useState({ cod: '', nome: '', linha: '', empresa: 'apoio', preco: '', img: '', ativo: true });

    function calcularPrecoFinal(cheio, descontos, ipiVal) {
      let preco = parseFloat(cheio) || 0;
      if (preco <= 0) return '';
      descontos.forEach(d => {
        preco = preco * (1 - d.valor / 100);
      });
      const ipiNum = parseFloat(ipiVal) || 0;
      if (ipiNum > 0) preco = preco * (1 + ipiNum / 100);
      return preco.toFixed(2);
    }

    function toggleDesconto(d) {
      setDescontosSel(prev => {
        const existe = prev.find(x => x.id === d.id);
        const novos = existe ? prev.filter(x => x.id !== d.id) : [...prev, d];
        const finalCalc = calcularPrecoFinal(precoCheio, novos, ipi);
        if (finalCalc) setForm(f => ({ ...f, preco: finalCalc }));
        return novos;
      });
    }

    function handlePrecoCheioChange(val) {
      setPrecoCheio(val);
      const finalCalc = calcularPrecoFinal(val, descontosSel, ipi);
      if (finalCalc) setForm(prev => ({ ...prev, preco: finalCalc }));
    }

    function handleIpiChange(val) {
      setIpi(val);
      const finalCalc = calcularPrecoFinal(precoCheio, descontosSel, val);
      if (finalCalc) setForm(prev => ({ ...prev, preco: finalCalc }));
    }

    useEffect(() => { carregarProds(); }, []);

    async function carregarProds() {
      setLoading(true);
      try {
        const lista = await listarProdutos();
        lista.sort((a, b) => a.nome?.localeCompare(b.nome));
        setProdutos(lista);
      } catch (e) { console.error(e); }
      setLoading(false);
    }

    function abrirNovo() {
      setEditando(null);
      setForm({ cod: '', nome: '', linha: '', empresa: 'apoio', preco: '', img: '', ativo: true });
      setPrecoCheio('');
      setDescontosSel([]);
      setIpi('');
      setModalProd(true);
    }

    function abrirEditar(p) {
      setEditando(p);
      setForm({ cod: p.cod || '', nome: p.nome || '', linha: p.linha || '', empresa: p.empresa || 'apoio', preco: p.preco !== undefined ? String(p.preco) : '', img: p.img || '', ativo: p.ativo !== false });
      setPrecoCheio('');
      setDescontosSel([]);
      setIpi('');
      setModalProd(true);
    }

    async function handleUploadFoto(e) {
      const file = e.target.files[0];
      if (!file) return;
      setUploadando(true);
      try {
        const data = new FormData();
        data.append('file', file);
        data.append('upload_preset', CLOUDINARY_PRESET);
        const res = await fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload', { method: 'POST', body: data });
        const json = await res.json();
        if (json.secure_url) { setForm(prev => ({ ...prev, img: json.secure_url })); }
        else { alert('Erro ao fazer upload. Tente novamente.'); }
      } catch (err) { alert('Erro ao fazer upload da imagem.'); console.error(err); }
      setUploadando(false);
    }

    async function handleSalvar() {
      if (!form.cod || !form.nome || !form.linha) { alert('Preencha codigo, nome e linha!'); return; }
      setSalvando(true);
      try {
        const dados = { cod: form.cod.trim(), nome: form.nome.trim(), linha: form.linha.trim(), empresa: form.empresa, preco: parseFloat(form.preco) || 0, ipi: parseFloat(ipi) || 0, img: form.img.trim() || null, ativo: form.ativo };
        if (editando) { await atualizarProduto(editando.id, dados); }
        else { await salvarProduto(dados); }
        await carregarProds();
        setModalProd(false);
      } catch (e) { alert('Erro ao salvar.'); }
      setSalvando(false);
    }

    async function handleDeletar(p) {
      if (!window.confirm('Deletar "' + p.nome + '"?')) return;
      try { await deletarProduto(p.id); await carregarProds(); } catch (e) { alert('Erro ao deletar.'); }
    }

    async function handleToggle(p) {
      try { await atualizarProduto(p.id, { ativo: !p.ativo }); await carregarProds(); } catch (e) { alert('Erro.'); }
    }

    const linhasDisponiveis = [...new Set(produtos.map(p => p.linha).filter(Boolean))].filter(l => l !== 'OUTROS').sort();
    const prodFiltrados = produtos.filter(p => filtroLinha === '' || p.linha === filtroLinha);
    const inputSP = { width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd', borderRadius: 8, padding: '9px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box', color: '#1a1a1a', fontFamily: 'inherit' };

    const precoFinalCalc = calcularPrecoFinal(precoCheio, descontosSel);

    return (
      <>
        <button onClick={abrirNovo} style={{ width: '100%', background: ROXO, border: 'none', borderRadius: 10, padding: '12px', fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', marginBottom: 12 }}>
          + Adicionar Novo Produto
        </button>

        <div style={{ display: 'flex', gap: 7, marginBottom: 12, overflowX: 'auto', paddingBottom: 2 }}>
          {linhasDisponiveis.map(linha => (
            <div key={linha} onClick={() => setFiltroLinha(filtroLinha === linha ? '' : linha)}
              style={{ flexShrink: 0, background: filtroLinha === linha ? ROXO : '#f4f4f2', border: '1px solid ' + (filtroLinha === linha ? ROXO : '#e0e0dd'), borderRadius: 20, padding: '5px 13px', fontSize: 11, fontWeight: 500, color: filtroLinha === linha ? '#fff' : '#555', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              {NOMES_LINHAS[linha] || linha}
            </div>
          ))}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#aaa' }}>Carregando...</div>
        ) : prodFiltrados.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa', fontSize: 13 }}>Nenhum produto cadastrado ainda</div>
        ) : (
          prodFiltrados.map(p => (
            <div key={p.id} style={{ background: '#fff', borderRadius: 10, border: '1px solid ' + (p.ativo ? '#e8e8e5' : '#fecaca'), padding: '12px', marginBottom: 10, opacity: p.ativo ? 1 : 0.6 }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <div
                  onClick={() => p.img ? setFotoZoom({ url: getImgUrl(p.img), nome: p.nome }) : null}
                  style={{ width: 44, height: 44, background: '#f8f8f7', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: p.img ? 'zoom-in' : 'default', position: 'relative' }}>
                  {p.img ? (
                    <>
                      <img src={getImgUrl(p.img)} alt={p.nome} style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 4 }} onError={e => { e.target.style.display = 'none'; }} />
                      <div style={{ position: 'absolute', bottom: 1, right: 1, background: 'rgba(27,58,107,0.75)', borderRadius: '50%', width: 14, height: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8 }}>🔍</div>
                    </>
                  ) : (
                    <span style={{ fontSize: 20 }}>📦</span>
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.nome}</div>
                  <div style={{ fontSize: 10, color: '#aaa' }}>{p.cod} - {NOMES_LINHAS[p.linha] || p.linha}</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: AZUL, marginTop: 2 }}>
                    {p.preco > 0 ? 'R$ ' + Number(p.preco).toFixed(2).replace('.', ',') : 'Consultar'}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <button onClick={() => abrirEditar(p)} style={{ background: AZUL, border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 10, color: '#fff', fontWeight: 600, cursor: 'pointer' }}>Editar</button>
                  <button onClick={() => handleToggle(p)} style={{ background: p.ativo ? '#f59e0b' : '#16a34a', border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 10, color: '#fff', fontWeight: 600, cursor: 'pointer' }}>{p.ativo ? 'Ocultar' : 'Ativar'}</button>
                  <button onClick={() => handleDeletar(p)} style={{ background: '#fff5f5', border: '1px solid #fecaca', borderRadius: 6, padding: '5px 10px', fontSize: 10, color: '#e53e3e', fontWeight: 600, cursor: 'pointer' }}>Deletar</button>
                </div>
              </div>
            </div>
          ))
        )}
        {modalProd && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 200 }}>
            <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 16 }}>{editando ? 'Editar Produto' : 'Novo Produto'}</div>

              {[{ campo: 'cod', label: 'Codigo *', placeholder: 'Ex: L7000' }, { campo: 'nome', label: 'Nome *', placeholder: 'Ex: Interruptor Simples 10A' }, { campo: 'linha', label: 'Linha *', placeholder: 'Ex: ILB' }].map(f => (
                <div key={f.campo} style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>{f.label}</label>
                  <input value={form[f.campo]} onChange={e => setForm(prev => ({ ...prev, [f.campo]: e.target.value }))} placeholder={f.placeholder} style={inputSP} />
                </div>
              ))}

              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>Empresa *</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  {[{ id: 'apoio', label: 'Apoio' }].map(e => (
                    <div key={e.id} onClick={() => setForm(prev => ({ ...prev, empresa: e.id }))}
                      style={{ flex: 1, textAlign: 'center', padding: '9px', borderRadius: 8, border: '2px solid ' + (form.empresa === e.id ? ROXO : '#e0e0dd'), background: form.empresa === e.id ? '#f5f0ff' : '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                      {e.label}
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ background: '#f8f4ff', border: '1px solid #e0d0ff', borderRadius: 10, padding: '12px', marginBottom: 10 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: '#5b21b6', display: 'block', marginBottom: 8 }}>Calculadora de Preco</label>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>Preco Cheio (R$)</label>
                  <input value={precoCheio} onChange={e => handlePrecoCheioChange(e.target.value)} placeholder="Ex: 10.00" type="number" step="0.01" style={{ ...inputSP, background: '#fff' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 6 }}>Descontos em Cascata</label>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {DESCONTOS.map(d => {
                      const sel = descontosSel.find(x => x.id === d.id);
                      return (
                        <div key={d.id} onClick={() => toggleDesconto(d)}
                          style={{ padding: '6px 14px', borderRadius: 20, border: '2px solid ' + (sel ? ROXO : '#e0e0dd'), background: sel ? ROXO : '#fff', color: sel ? '#fff' : '#555', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                          -{d.label}
                        </div>
                      );
                    })}
                  </div>
                </div>
                {precoCheio && descontosSel.length > 0 && (
                  <div style={{ background: '#fff', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#333' }}>
                    <div style={{ fontSize: 10, color: '#888', marginBottom: 4 }}>Calculo em cascata:</div>
                    {(() => {
                      let p = parseFloat(precoCheio) || 0;
                      return descontosSel.map((d, i) => {
                        const antes = p;
                        p = p * (1 - d.valor / 100);
                        return (<div key={d.id} style={{ fontSize: 11, color: '#555' }}>R$ {antes.toFixed(2)} - {d.label} = R$ {p.toFixed(2)}</div>);
                      });
                    })()}
                  </div>
                )}
                <div style={{ marginTop: 10 }}>
                  <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>IPI (%)</label>
                  <input value={ipi} onChange={e => handleIpiChange(e.target.value)} placeholder="Ex: 10 (deixe vazio se nao houver)" type="number" step="0.01" style={{ ...inputSP, background: '#fff' }} />
                  {ipi && parseFloat(ipi) > 0 && precoCheio && (
                    <div style={{ fontSize: 10, color: '#f59e0b', marginTop: 3, fontWeight: 600 }}>+ IPI {ipi}% aplicado ao preco com desconto</div>
                  )}
                </div>
              </div>

              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>Preco Final (R$)</label>
                <input value={form.preco} onChange={e => setForm(prev => ({ ...prev, preco: e.target.value }))} placeholder="Ex: 4.90 (deixe 0 para Consultar)" type="number" step="0.01"
                  style={{ ...inputSP, fontWeight: 700, color: AZUL, background: precoFinalCalc ? '#f0fff4' : '#f8f8f7', border: '1px solid ' + (precoFinalCalc ? '#86efac' : '#e0e0dd') }} />
                {precoFinalCalc && <div style={{ fontSize: 10, color: '#16a34a', marginTop: 3, fontWeight: 600 }}>Preco calculado automaticamente</div>}
              </div>

              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>Foto do Produto</label>
                <div style={{ background: '#f8f8f7', border: '2px dashed #e0e0dd', borderRadius: 10, padding: '12px', marginBottom: 8, textAlign: 'center' }}>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>Escolher arquivo do computador</div>
                  <input type="file" accept="image/*" onChange={handleUploadFoto} style={{ fontSize: 12, cursor: 'pointer' }} />
                  {uploadando && <div style={{ fontSize: 11, color: AZUL, marginTop: 8, fontWeight: 600 }}>Enviando foto...</div>}
                </div>
                <div style={{ fontSize: 10, color: '#aaa', marginBottom: 4, textAlign: 'center' }}>ou</div>
                <input value={form.img} onChange={e => setForm(prev => ({ ...prev, img: e.target.value }))} placeholder="Cole codigo Apoio (ex: L70002) ou URL da imagem" style={inputSP} />
                {form.img && (
                  <div style={{ marginTop: 10, textAlign: 'center' }}>
                    <img src={form.img.startsWith('http') ? form.img : 'https://www.apoio.ind.br/media/img/produtos/' + form.img + '.jpg'} alt="preview"
                      style={{ width: 100, height: 100, objectFit: 'contain', borderRadius: 10, border: '1px solid #e0e0dd' }}
                      onError={e => { e.target.style.display = 'none'; }} />
                    <div style={{ fontSize: 10, color: '#16a34a', marginTop: 4 }}>Imagem carregada</div>
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                <input type="checkbox" checked={form.ativo} onChange={e => setForm(prev => ({ ...prev, ativo: e.target.checked }))} />
                <label style={{ fontSize: 12, color: '#555' }}>Produto ativo (visivel no catalogo)</label>
              </div>

              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => setModalProd(false)} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
                <button onClick={handleSalvar} disabled={salvando || uploadando} style={{ flex: 2, background: salvando || uploadando ? '#aaa' : ROXO, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>
                  {salvando ? 'Salvando...' : uploadando ? 'Aguarde upload...' : 'Salvar Produto'}
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA }}>

      <div style={{ background: ROXO, padding: '14px 18px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>⚙️</div>
            <div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)' }}>Painel Administrativo</div>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>Apoio Materiais Elétricos</div>
              <div onClick={() => onNavegar('home')} style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', cursor: 'pointer', marginTop: 2 }}>Voltar ao inicio</div>
            </div>
          </div>
          <button onClick={handleLogout} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 10px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>Sair</button>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          {[
            { id: 'resumo',     label: 'Resumo' },
            { id: 'pedidos',    label: 'Pedidos' + (pedidos.length > 0 ? '(' + pedidos.length + ')' : '') },
            { id: 'clientes',   label: 'Clientes' + (clientes.length > 0 ? '(' + clientes.length + ')' : '') },
            { id: 'vendedores', label: 'Vendedores' + (vendedores.length > 0 ? '(' + vendedores.length + ')' : '') },
            { id: 'produtos',   label: 'Produtos' },
          ].map(aba => (
            <button key={aba.id} onClick={() => setAbaAtiva(aba.id)}
              style={{ flex: 1, background: abaAtiva === aba.id ? '#fff' : 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 8, padding: '7px 2px', fontSize: 10, fontWeight: 600, color: abaAtiva === aba.id ? ROXO : 'rgba(255,255,255,0.8)', cursor: 'pointer' }}>
              {aba.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 12px 0' }}>

        {abaAtiva === 'resumo' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 14 }}>
              {[
                { label: 'Total de Pedidos', valor: String(totalPedidos),  cor: AZUL    },
                { label: 'Pendentes',        valor: String(totalPendentes), cor: LARANJA },
                { label: 'Faturamento',      valor: faturamentoFormatado,  cor: VERDE   },
              ].map(ind => (
                <div key={ind.label} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '10px 8px', textAlign: 'center' }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: ind.cor }}>{ind.valor}</div>
                  <div style={{ fontSize: 9, color: '#aaa', marginTop: 2, lineHeight: 1.3 }}>{ind.label}</div>
                </div>
              ))}
            </div>
            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a' }}>Ultimos Pedidos</span>
                <span onClick={() => setAbaAtiva('pedidos')} style={{ fontSize: 11, color: ROXO, fontWeight: 500, cursor: 'pointer' }}>Ver todos</span>
              </div>
              {pedidos.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '16px 0', color: '#aaa', fontSize: 12 }}>Nenhum pedido ainda</div>
              ) : (
                pedidos.slice(0, 3).map(p => {
                  const st = STATUS[p.status] || STATUS['pendente'];
                  return (
                    <div key={p.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f4f4f2' }}>
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 600, color: '#1a1a1a' }}>{p.clienteRazaoSocial || p.clienteNome}</div>
                        <div style={{ fontSize: 10, color: '#aaa' }}>#{p.id.slice(-6).toUpperCase()} - {formatarData(p.criadoEm)}</div>
                        <div style={{ fontSize: 9, color: p.vendedorId ? '#16a34a' : '#f59e0b' }}>{p.vendedorId ? nomeVendedor(p.vendedorId) : 'Sem vendedor'}</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: AZUL }}>{formatarTotal(p.total)}</div>
                        <div style={{ background: st.bg, borderRadius: 10, padding: '2px 7px', fontSize: 9, fontWeight: 700, color: st.cor, marginTop: 3 }}>{st.label}</div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a' }}>Vendedores Cadastrados</span>
                <span onClick={() => setAbaAtiva('vendedores')} style={{ fontSize: 11, color: ROXO, fontWeight: 500, cursor: 'pointer' }}>Ver todos</span>
              </div>
              {vendedores.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '16px 0', color: '#aaa', fontSize: 12 }}>Nenhum vendedor ainda</div>
              ) : (
                vendedores.slice(0, 3).map(v => (
                  <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', borderBottom: '1px solid #f4f4f2' }}>
                    <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: AZUL, flexShrink: 0 }}>
                      {v.nome.split(' ').map(n => n[0]).slice(0, 2).join('')}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, fontWeight: 500, color: '#1a1a1a' }}>{v.nome}</div>
                      <div style={{ fontSize: 10, color: '#aaa' }}>Comissao: {v.comissao}%</div>
                    </div>
                    <div style={{ background: '#f0fdf4', borderRadius: 10, padding: '2px 7px', fontSize: 9, fontWeight: 700, color: '#16a34a' }}>Ativo</div>
                  </div>
                ))
              )}
            </div>
          </>
        )}

        {abaAtiva === 'pedidos' && (
          <>
            <div style={{ display: 'flex', gap: 6, marginBottom: 12, overflowX: 'auto' }}>
              {[{ id: 'todos', label: 'Todos' }, { id: 'pendente', label: 'Aguardando' }, { id: 'confirmado', label: 'Confirmado' }, { id: 'em_entrega', label: 'Em entrega' }, { id: 'entregue', label: 'Entregue' }].map(f => (
                <div key={f.id} onClick={() => setFiltroStatus(f.id)}
                  style={{ flexShrink: 0, background: filtroStatus === f.id ? ROXO : '#fff', border: '1px solid ' + (filtroStatus === f.id ? ROXO : '#e0e0dd'), borderRadius: 20, padding: '5px 12px', fontSize: 11, fontWeight: 600, color: filtroStatus === f.id ? '#fff' : '#555', cursor: 'pointer' }}>
                  {f.label}
                </div>
              ))}
            </div>
            {loadingPedidos ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa' }}>Carregando...</div>
            ) : pedidosFiltrados.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa', fontSize: 13 }}>Nenhum pedido encontrado</div>
            ) : (
              pedidosFiltrados.map(p => {
                const st = STATUS[p.status] || STATUS['pendente'];
                const proxSt = PROXIMOS_STATUS[p.status];
                const labelBtn = LABEL_BOTAO[p.status];
                return (
                  <div key={p.id} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1a1a' }}>{p.clienteRazaoSocial || p.clienteNome}</div>
                        <div style={{ fontSize: 10, color: '#aaa', marginTop: 1 }}>#{p.id.slice(-6).toUpperCase()} - {formatarData(p.criadoEm)}</div>
                        <div style={{ fontSize: 10, color: p.vendedorId ? '#16a34a' : '#f59e0b', marginTop: 1 }}>{p.vendedorId ? nomeVendedor(p.vendedorId) : 'Pedido direto'}</div>
                      </div>
                      <div style={{ background: st.bg, borderRadius: 10, padding: '3px 10px', fontSize: 10, fontWeight: 700, color: st.cor }}>{st.label}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                      <span style={{ fontSize: 15, fontWeight: 700, color: AZUL }}>{formatarTotal(p.total)}</span>
                      <span style={{ fontSize: 10, color: '#aaa' }}>{p.itens?.length || 0} produtos - {p.fornecedor || '-'}</span>
                    </div>
                    {p.pagamento && <div style={{ fontSize: 10, color: '#888', marginBottom: 8 }}>{p.pagamento} {p.prazo ? '- ' + p.prazo : ''}</div>}
                    {proxSt && labelBtn && (
                      <button onClick={() => handleAtualizarStatus(p)} disabled={atualizando === p.id}
                        style={{ width: '100%', background: atualizando === p.id ? '#aaa' : ROXO, border: 'none', borderRadius: 8, padding: '9px', fontSize: 12, fontWeight: 600, color: '#fff', cursor: atualizando === p.id ? 'not-allowed' : 'pointer' }}>
                        {atualizando === p.id ? 'Atualizando...' : labelBtn}
                      </button>
                    )}
                    {!proxSt && <div style={{ textAlign: 'center', fontSize: 11, color: '#16a34a', fontWeight: 600 }}>Pedido concluido</div>}
                  </div>
                );
              })
            )}
          </>
        )}

        {abaAtiva === 'clientes' && (
          <>
            <button onClick={() => setModalNovoCliente(true)}
              style={{ width: '100%', background: AZUL, border: 'none', borderRadius: 10, padding: '12px', fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', marginBottom: 12 }}>
              + Cadastrar Novo Cliente
            </button>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#888', marginBottom: 10 }}>
              {clientes.length} {clientes.length === 1 ? 'cliente cadastrado' : 'clientes cadastrados'}
            </div>
            {loadingClientes ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa' }}>Carregando...</div>
            ) : clientes.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa', fontSize: 13 }}>Nenhum cliente ainda</div>
            ) : (
              clientes.map(c => (
                <div key={c.id} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                    <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: AZUL, flexShrink: 0 }}>
                      {c.nome?.split(' ').map(n => n[0]).slice(0, 2).join('')}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a' }}>{c.nome}</div>
                      {c.razaoSocial && <div style={{ fontSize: 11, color: '#555', fontWeight: 500 }}>{c.razaoSocial}</div>}
                      <div style={{ fontSize: 11, color: '#aaa' }}>{c.email}</div>
                      <div style={{ fontSize: 11, color: '#aaa' }}>{c.cnpj || '-'}</div>
                    </div>
                  </div>
                  <div style={{ background: c.vendedorId ? '#f0fdf4' : '#fffbeb', borderRadius: 8, padding: '8px 10px', marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase' }}>Representante</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: c.vendedorId ? '#16a34a' : '#f59e0b' }}>{c.vendedorId ? nomeVendedor(c.vendedorId) : 'Sem representante'}</div>
                    </div>
                    <button onClick={() => { setModalVincular(c); setVendedorSelecionado(c.vendedorId || ''); }}
                      style={{ background: ROXO, border: 'none', borderRadius: 7, padding: '5px 10px', fontSize: 10, color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
                      {c.vendedorId ? 'Alterar' : 'Vincular'}
                    </button>
                  </div>
                  <div style={{ fontSize: 10, color: '#bbb', marginBottom: 10 }}>
                    {c.endereco?.cidade || ''}{c.endereco?.estado ? '/' + c.endereco.estado : ''}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <button onClick={() => handleConvidarWhatsApp(c)} style={{ flex: 1, background: '#25D366', border: 'none', borderRadius: 8, padding: '9px', fontSize: 11, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>Convidar WPP</button>
                    <button onClick={() => handleConvidarEmail(c)} style={{ flex: 1, background: AZUL, border: 'none', borderRadius: 8, padding: '9px', fontSize: 11, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>Convidar E-mail</button>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => abrirEditarCliente(c)} style={{ flex: 1, background: '#f0f4ff', border: '1px solid #c7d7f9', borderRadius: 8, padding: '9px', fontSize: 11, fontWeight: 600, color: AZUL, cursor: 'pointer' }}>Editar</button>
                    <button onClick={() => handleExcluirCliente(c)} disabled={excluindoCliente === c.id}
                      style={{ flex: 1, background: excluindoCliente === c.id ? '#aaa' : '#fff5f5', border: '1px solid #fecaca', borderRadius: 8, padding: '9px', fontSize: 11, fontWeight: 600, color: excluindoCliente === c.id ? '#fff' : '#e53e3e', cursor: excluindoCliente === c.id ? 'not-allowed' : 'pointer' }}>
                      {excluindoCliente === c.id ? 'Excluindo...' : 'Excluir'}
                    </button>
                  </div>
                </div>
              ))
            )}
          </>
        )}

        {abaAtiva === 'vendedores' && (
          <>
            <button onClick={() => setModalVendedor(true)}
              style={{ width: '100%', background: ROXO, border: 'none', borderRadius: 10, padding: '12px', fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', marginBottom: 14 }}>
              + Cadastrar Novo Vendedor
            </button>
            {loadingVend ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa' }}>Carregando...</div>
            ) : vendedores.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#aaa', fontSize: 13 }}>Nenhum vendedor ainda</div>
            ) : (
              vendedores.map(v => (
                <div key={v.id} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px', marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                    <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, color: AZUL, flexShrink: 0 }}>
                      {v.nome.split(' ').map(n => n[0]).slice(0, 2).join('')}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a' }}>{v.nome}</div>
                      <div style={{ fontSize: 11, color: '#aaa' }}>{v.email}</div>
                      <div style={{ fontSize: 11, color: '#aaa' }}>{v.telefone}</div>
                      <div style={{ fontSize: 11, color: '#aaa' }}>WhatsApp: {v.whatsapp || 'Nao cadastrado'}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 18, fontWeight: 800, color: ROXO }}>{v.comissao}%</div>
                      <div style={{ fontSize: 9, color: '#aaa' }}>comissao</div>
                    </div>
                  </div>
                  <div style={{ background: '#f4f4f2', borderRadius: 8, padding: '8px 10px', marginBottom: 10 }}>
                    <span style={{ fontSize: 10, color: ROXO, fontWeight: 600 }}>https://inove-app-53fa7.web.app?ref={v.linkPersonalizado}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => handleWhatsAppVendedor(v)} style={{ flex: 2, background: '#25D366', border: 'none', borderRadius: 8, padding: '8px', fontSize: 11, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>Enviar Link pelo WhatsApp</button>
                    <button onClick={() => abrirEditarVendedor(v)} style={{ flex: 1, background: '#f0f4ff', border: '1px solid #c7d7f9', borderRadius: 8, padding: '8px', fontSize: 11, fontWeight: 600, color: AZUL, cursor: 'pointer' }}>Editar</button>
                    <button onClick={() => handleExcluirVendedor(v.id)} disabled={excluindo === v.id}
                      style={{ flex: 1, background: excluindo === v.id ? '#aaa' : '#fff5f5', border: '1px solid #fecaca', borderRadius: 8, padding: '8px', fontSize: 11, fontWeight: 600, color: excluindo === v.id ? '#fff' : '#e53e3e', cursor: excluindo === v.id ? 'not-allowed' : 'pointer' }}>
                      {excluindo === v.id ? 'Excluindo...' : 'Excluir'}
                    </button>
                  </div>
                </div>
              ))
            )}
          </>
        )}

        {abaAtiva === 'produtos' && <AbaProdutos />}
        <div style={{ height: 12 }} />
      </div>

      <div style={{ background: '#fff', borderTop: '1px solid #e8e8e5', display: 'flex' }}>
        {[
          { id: 'resumo',     label: 'Resumo'     },
          { id: 'pedidos',    label: 'Pedidos'    },
          { id: 'clientes',   label: 'Clientes'   },
          { id: 'vendedores', label: 'Vendedores' },
          { id: 'produtos',   label: 'Produtos'   },
        ].map(item => (
          <div key={item.id} onClick={() => setAbaAtiva(item.id)}
            style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px 4px 6px', cursor: 'pointer', gap: 3 }}>
            <span style={{ fontSize: 9, color: abaAtiva === item.id ? ROXO : '#bbb', fontWeight: abaAtiva === item.id ? 600 : 400 }}>{item.label}</span>
          </div>
        ))}
      </div>

      {/* Modal zoom da foto com efeito verniz */}
      {fotoZoom && (
        <div onClick={() => setFotoZoom(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 20 }}>
          <div style={{ position: 'absolute', top: 20, right: 20, width: 36, height: 36, background: 'rgba(255,255,255,0.15)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, color: '#fff', cursor: 'pointer' }}>✕</div>
          <div style={{ background: '#ffffff', borderRadius: 16, padding: 16, width: '100%', maxWidth: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, boxShadow: '0 4px 32px rgba(27,58,107,0.25)' }}>
            <img src={fotoZoom.url} alt={fotoZoom.nome} style={{ width: '100%', maxHeight: 280, objectFit: 'contain', borderRadius: 8, filter: 'drop-shadow(0px 6px 14px rgba(0,0,0,0.20)) contrast(1.15) brightness(1.05) saturate(1.2)' }} onError={e => { e.target.src = ''; }} />
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', textAlign: 'center' }}>{fotoZoom.nome}</div>
            <div style={{ fontSize: 11, color: '#aaa', textAlign: 'center' }}>Toque fora para fechar</div>
          </div>
        </div>
      )}

      {modalVendedor && (
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%', maxHeight: '85vh', overflowY: 'auto' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 16 }}>Cadastrar Vendedor</div>
            {[
              { campo: 'nome',     label: 'Nome completo *',      placeholder: 'Ex: Joao Silva',  type: 'text'   },
              { campo: 'email',    label: 'E-mail *',             placeholder: 'joao@email.com',  type: 'email'  },
              { campo: 'telefone', label: 'Telefone *',           placeholder: '(11) 99999-0000', type: 'tel'    },
              { campo: 'whatsapp', label: 'WhatsApp (com DDD) *', placeholder: '11999990000',     type: 'tel'    },
              { campo: 'comissao', label: 'Comissao (%) *',       placeholder: 'Ex: 5',           type: 'number' },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, fontWeight: 500, color: '#666', display: 'block', marginBottom: 4 }}>{f.label}</label>
                <input value={formVend[f.campo]} onChange={e => setFormVend(prev => ({ ...prev, [f.campo]: e.target.value }))}
                  placeholder={f.placeholder} type={f.type} style={inputStyle(f.campo)} />
                {errosVend[f.campo] && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{errosVend[f.campo]}</div>}
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <button onClick={() => { setModalVendedor(false); setErrosVend({}); }} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={handleSalvarVendedor} style={{ flex: 2, background: salvandoVend ? '#aaa' : ROXO, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>{salvandoVend ? 'Salvando...' : 'Cadastrar Vendedor'}</button>
            </div>
          </div>
        </div>
      )}

      {modalEditarVend && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 200 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%', maxHeight: '85vh', overflowY: 'auto', boxSizing: 'border-box' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 4 }}>Editar Vendedor</div>
            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 16 }}>{modalEditarVend.nome} - {modalEditarVend.email}</div>
            <div style={{ background: '#f8f8f7', borderRadius: 8, padding: '8px 12px', marginBottom: 14 }}>
              <div style={{ fontSize: 10, color: '#aaa' }}>Nome e e-mail nao podem ser alterados aqui</div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelS}>Telefone</label>
              <input value={formEditarVend.telefone} type="tel" placeholder="(11) 99999-0000" onChange={e => setFormEditarVend(prev => ({ ...prev, telefone: e.target.value }))} style={inputS} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelS}>WhatsApp (com DDD)</label>
              <input value={formEditarVend.whatsapp} type="tel" placeholder="11999990000" onChange={e => setFormEditarVend(prev => ({ ...prev, whatsapp: e.target.value }))} style={inputS} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={labelS}>Comissao (%)</label>
              <input value={formEditarVend.comissao} type="number" placeholder="Ex: 5" onChange={e => setFormEditarVend(prev => ({ ...prev, comissao: e.target.value }))} style={inputS} />
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <button onClick={() => setModalEditarVend(null)} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={handleSalvarEditarVendedor} disabled={salvandoEditarVend} style={{ flex: 2, background: salvandoEditarVend ? '#aaa' : ROXO, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>{salvandoEditarVend ? 'Salvando...' : 'Salvar Alteracoes'}</button>
            </div>
          </div>
        </div>
      )}

      {modalVincular && (
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 4 }}>Vincular Representante</div>
            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 16 }}>Cliente: {modalVincular.nome}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
              <div onClick={() => setVendedorSelecionado('')}
                style={{ padding: '10px 12px', borderRadius: 8, border: '2px solid ' + (vendedorSelecionado === '' ? ROXO : '#e0e0dd'), background: vendedorSelecionado === '' ? '#f5f0ff' : '#fff', cursor: 'pointer', fontSize: 12, color: '#555' }}>
                Sem representante
              </div>
              {vendedores.map(v => (
                <div key={v.id} onClick={() => setVendedorSelecionado(v.uid || v.id)}
                  style={{ padding: '10px 12px', borderRadius: 8, border: '2px solid ' + (vendedorSelecionado === (v.uid || v.id) ? ROXO : '#e0e0dd'), background: vendedorSelecionado === (v.uid || v.id) ? '#f5f0ff' : '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: AZUL }}>
                    {v.nome.split(' ').map(n => n[0]).slice(0, 2).join('')}
                  </div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a' }}>{v.nome}</div>
                    <div style={{ fontSize: 10, color: '#aaa' }}>Comissao: {v.comissao}%</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setModalVincular(null); setVendedorSelecionado(''); }} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={handleVincularVendedor} disabled={vinculando} style={{ flex: 2, background: vinculando ? '#aaa' : ROXO, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>{vinculando ? 'Salvando...' : 'Confirmar Vinculo'}</button>
            </div>
          </div>
        </div>
      )}

      {modalNovoCliente && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 200 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%', maxHeight: '92vh', overflowY: 'auto', boxSizing: 'border-box' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 16 }}>Cadastrar Novo Cliente</div>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 }}>Dados Pessoais</div>
            {[
              { campo: 'nome',        label: 'Nome completo *', type: 'text'  },
              { campo: 'razaoSocial', label: 'Razao Social',    type: 'text'  },
              { campo: 'email',       label: 'E-mail *',        type: 'email' },
              { campo: 'telefone',    label: 'Telefone',        type: 'tel'   },
              { campo: 'cnpj',        label: 'CNPJ / CPF',      type: 'text'  },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 10 }}>
                <label style={labelS}>{f.label}</label>
                <input value={formNovoCliente[f.campo] || ''} type={f.type} onChange={e => setFormNovoCliente(prev => ({ ...prev, [f.campo]: e.target.value }))}
                  style={{ ...inputS, background: errosNovoCliente[f.campo] ? '#fff5f5' : '#f8f8f7', border: '1px solid ' + (errosNovoCliente[f.campo] ? '#fca5a5' : '#e0e0dd') }} />
                {errosNovoCliente[f.campo] && <div style={{ fontSize: 10, color: '#e53e3e', marginTop: 3 }}>{errosNovoCliente[f.campo]}</div>}
              </div>
            ))}
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8, marginTop: 4 }}>Endereco</div>
            {[
              { campo: 'rua',    label: 'Rua / Avenida' },
              { campo: 'numero', label: 'Numero'        },
              { campo: 'cidade', label: 'Cidade'        },
              { campo: 'estado', label: 'Estado (UF)'   },
              { campo: 'cep',    label: 'CEP'           },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 10 }}>
                <label style={labelS}>{f.label}</label>
                <input value={formNovoCliente[f.campo] || ''} onChange={e => setFormNovoCliente(prev => ({ ...prev, [f.campo]: e.target.value }))} style={inputS} maxLength={f.campo === 'estado' ? 2 : undefined} />
              </div>
            ))}
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8, marginTop: 4 }}>Representante (opcional)</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
              <div onClick={() => setFormNovoCliente(prev => ({ ...prev, vendedorId: '' }))}
                style={{ padding: '8px 12px', borderRadius: 8, border: '2px solid ' + (!formNovoCliente.vendedorId ? ROXO : '#e0e0dd'), background: !formNovoCliente.vendedorId ? '#f5f0ff' : '#fff', cursor: 'pointer', fontSize: 12, color: '#555' }}>
                Sem representante
              </div>
              {vendedores.map(v => (
                <div key={v.id} onClick={() => setFormNovoCliente(prev => ({ ...prev, vendedorId: v.uid || v.id }))}
                  style={{ padding: '8px 12px', borderRadius: 8, border: '2px solid ' + (formNovoCliente.vendedorId === (v.uid || v.id) ? ROXO : '#e0e0dd'), background: formNovoCliente.vendedorId === (v.uid || v.id) ? '#f5f0ff' : '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700, color: AZUL }}>
                    {v.nome.split(' ').map(n => n[0]).slice(0, 2).join('')}
                  </div>
                  <span style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a' }}>{v.nome}</span>
                </div>
              ))}
            </div>
            <div style={{ background: '#fffbeb', borderRadius: 8, padding: '8px 12px', marginBottom: 14, border: '1px solid #fde68a' }}>
              <div style={{ fontSize: 11, color: '#92400e' }}>Senha gerada automaticamente: apoio@ + primeiros 6 chars do nome</div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setModalNovoCliente(false); setErrosNovoCliente({}); }} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={handleCadastrarNovoCliente} disabled={salvandoNovoCliente} style={{ flex: 2, background: salvandoNovoCliente ? '#aaa' : AZUL, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>{salvandoNovoCliente ? 'Cadastrando...' : 'Cadastrar Cliente'}</button>
            </div>
          </div>
        </div>
      )}

      {modalEditarCliente && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 200 }}>
          <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 20px 24px', width: '100%', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 16 }}>Editar Cliente</div>
            {[
              { campo: 'nome',        label: 'Nome completo',       type: 'text' },
              { campo: 'razaoSocial', label: 'Razao Social',        type: 'text' },
              { campo: 'telefone',    label: 'Telefone / WhatsApp', type: 'tel'  },
              { campo: 'cnpj',        label: 'CNPJ / CPF',          type: 'text' },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 12 }}>
                <label style={labelS}>{f.label}</label>
                <input value={formCliente[f.campo] || ''} onChange={e => setFormCliente(prev => ({ ...prev, [f.campo]: e.target.value }))} type={f.type} style={inputS} />
              </div>
            ))}
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 10, marginTop: 4 }}>Endereco</div>
            {[
              { campo: 'rua',    label: 'Rua / Avenida' },
              { campo: 'numero', label: 'Numero'        },
              { campo: 'cidade', label: 'Cidade'        },
              { campo: 'estado', label: 'Estado (UF)'   },
              { campo: 'cep',    label: 'CEP'           },
            ].map(f => (
              <div key={f.campo} style={{ marginBottom: 12 }}>
                <label style={labelS}>{f.label}</label>
                <input value={formCliente[f.campo] || ''} onChange={e => setFormCliente(prev => ({ ...prev, [f.campo]: e.target.value }))} style={inputS} maxLength={f.campo === 'estado' ? 2 : undefined} />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <button onClick={() => setModalEditarCliente(null)} style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={handleSalvarCliente} disabled={salvandoCliente} style={{ flex: 2, background: salvandoCliente ? '#aaa' : AZUL, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>{salvandoCliente ? 'Salvando...' : 'Salvar Alteracoes'}</button>
            </div>
          </div>
        </div>
      )}

      {modalExcluido && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: '24px 20px', width: '100%', maxWidth: 340 }}>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>✅</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a' }}>Vendedor excluido!</div>
              <div style={{ fontSize: 12, color: '#aaa', marginTop: 4 }}>{modalExcluido.nome}</div>
            </div>
            <div style={{ background: '#fffbeb', borderRadius: 10, padding: '12px 14px', marginBottom: 16, border: '1px solid #fde68a' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#92400e', marginBottom: 6 }}>Acao necessaria</div>
              <div style={{ fontSize: 11, color: '#78350f', lineHeight: 1.6 }}>A conta de login ainda existe. Delete para liberar o e-mail:</div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#92400e', marginTop: 6, wordBreak: 'break-all' }}>{modalExcluido.email}</div>
            </div>
            <a href="https://console.firebase.google.com/project/inove-app-53fa7/authentication/users" target="_blank" rel="noreferrer"
              style={{ display: 'block', width: '100%', background: ROXO, borderRadius: 10, padding: '12px', fontSize: 13, fontWeight: 600, color: '#fff', textAlign: 'center', textDecoration: 'none', marginBottom: 8, boxSizing: 'border-box' }}>
              Abrir Firebase Authentication
            </a>
            <button onClick={() => setModalExcluido(null)} style={{ width: '100%', background: '#f4f4f2', border: 'none', borderRadius: 10, padding: '12px', fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>Fechar</button>
          </div>
        </div>
      )}

    </div>
  );
}

export default PainelAdmin;